import { groupBy, orderBy } from "lodash";
import { ItensMapaFertilidadeTypes } from "../../../../../../../../../../../services/Laboratorio/osResultado";

//TYPES
type typekrigragemProcessada = {
        bounds: any, 
        circle: number[], 
        dataProfundidade: ItensMapaFertilidadeTypes[], 
        krigagem: {
            url: string;
            colors: unknown[];
            descriptionElemento: any;
            ordem: number;
            bounds: any;
            valor_interpretado: any;
        }[]
    }

export function obterListaSumario(krigagem_processada: typekrigragemProcessada[], tipo_representacao: 'Interpretado' | 'Distribuído') {

    let pagina = 5;
    const cod_prescricoes = new Set([30, 31, 32, 41, 42, 43, 44, 45, 46, 49]);
    const cod_indicadores = new Set([28, 33, 34, 38, 50]);
    
    let apenas_profundidade = krigagem_processada.map((item, index)=> {
        let contagem_paginas_elementos = index===0 ? 0 : (item?.krigagem ?? []).length;
        let pagina_book = Number(pagina) + index + Number(contagem_paginas_elementos);
        pagina =  pagina_book;

        let isIndicadores = (item.dataProfundidade).some(indi=> cod_indicadores.has(indi.cod_elemento));
        let isPrescricoes = (item.dataProfundidade).some(indi=> cod_prescricoes.has(indi.cod_elemento));
        let pagina_elementos = (item.krigagem).map((krigagem, index_elemento)=> {
            return {
                ...krigagem,
                descriptionElemento: krigagem.descriptionElemento+':',
                pagina_elemento: pagina + (index_elemento + 1)
            }
        })

        function nomeProfundidade() {
            if (isIndicadores) {
                return 'Indicadores: '
            }
            if (isPrescricoes) {
                return 'Prescrições: '
            }

            let profundidade = (item.dataProfundidade?.[0]?.profundidade)?.replace('-', ' a ');

            return `Pontos coletados ${profundidade} ${tipo_representacao}: `
        }

        return {
            cod_profundidade:item.dataProfundidade?.[0]?.cod_propriedade,
            nome_profundidade: nomeProfundidade(),
            lista_elementos: pagina_elementos,
            pagina: pagina

        }
    });

    return apenas_profundidade;
}

export function obterListaSumario2(krigagem_processada: typekrigragemProcessada[], tipo_representacao: 'Interpretado' | 'Distribuído' | 'null') {

    const cod_prescricoes = new Set([30, 31, 32, 41, 42, 43, 44, 45, 46, 49]);
    const cod_indicadores = new Set([28, 33, 34, 38, 50]);

    let ordenar_profundidades = krigagem_processada.map((item)=> {
        let is_indicadores = cod_indicadores.has(item?.dataProfundidade?.[0]?.cod_elemento);
        let is_prescricoes = cod_prescricoes.has(item?.dataProfundidade?.[0]?.cod_elemento);
        return {
            ...item,
            ordem_profundidade: is_prescricoes ? 3 : (is_indicadores ? 2 : 1) //NOSONAR
        }
    })

    let listagem_unica = (orderBy(ordenar_profundidades, 'ordem_profundidade', 'asc')).map((item)=> {

        let isIndicadores = (item.dataProfundidade).some(indi=> cod_indicadores.has(indi.cod_elemento));
        let isPrescricoes = (item.dataProfundidade).some(indi=> cod_prescricoes.has(indi.cod_elemento));

        function nomeProfundidade() {
            if (isIndicadores) {
                return 'Indicadores: '
            }
            if (isPrescricoes) {
                return 'Prescrições: '
            }
            let profundidade = (item.dataProfundidade?.[0]?.profundidade)?.replace('-', ' a ');
            let pronfundidade_granulometria = profundidade?.replace("00 a 50", "Granulometria");
            return `Pontos coletados ${pronfundidade_granulometria} ${tipo_representacao}: `
        }
        function nomeProfundidadePura() {
            if (isIndicadores) {
                return 'Indicadores: '
            }
            if (isPrescricoes) {
                return 'Prescrições: '
            }
            let profundidade = (item.dataProfundidade?.[0]?.profundidade)?.replace('-', ' a ');
            let pronfundidade_granulometria = profundidade?.replace("00 a 50", "Granulometria");
            return `${pronfundidade_granulometria} ${tipo_representacao}: `
        }

        let listagem = (item.krigagem).map((krigagem)=> {
            return {
                descricao: `${nomeProfundidade()}__`+krigagem.descriptionElemento+':'
            }
        });

        let push_listagem = [...listagem, {descricao: `${nomeProfundidade()}__Resumo de análises ${nomeProfundidadePura()}`}];

        return {
            descricao: `profundidade_${nomeProfundidade()}`,
            listagem: push_listagem
        }
    });
    //@ts-ignore
    let flat_listagem = listagem_unica.flatMap(item => [ 
        { descricao: item.descricao }, 
        ...(item.listagem ?? []) 
    ]);

    let remover_resumo_pres_indi = flat_listagem.filter(item=> item.descricao !== 'Prescrições: __Resumo de análises Prescrições: ' && item.descricao !== 'Indicadores: __Resumo de análises Indicadores: ')

    let paginar_lista = (remover_resumo_pres_indi??[]).map((item, index)=> {
        return {
            ...item,
            pagina: index + 5
        }
    })


    let separar_lista = paginar_lista.map(({ descricao, pagina })=> {

        let is_profundidade = String(descricao).startsWith('profundidade_');

        return {
            tipo: is_profundidade ? 'profundidade' : 'elemento',
            nome_profundidade: `${(descricao.split('__')?.[0])?.replace('profundidade_','')}`,
            nome_elemento: is_profundidade ? descricao?.replace('profundidade_','') : descricao.split('__')?.[1],
            pagina: pagina
        }
    });

    let agrupar = groupBy(separar_lista, 'nome_profundidade');

    let listagem_final = Object.entries(agrupar).map(([profundidade, lista_elementos])=>{
        return {
            nome_profundidade: profundidade,
            lista_elementos: lista_elementos.filter((_item, index)=> index!==0),
            pagina: Number(lista_elementos?.[0]?.pagina)
        }
    })
    
    return listagem_final ?? []
}